export default __webpack_public_path__ + "static/media/045-ladybug.c0ceb19a.svg";